import { render, staticRenderFns } from "./SizeFamilyDialog.vue?vue&type=template&id=773df7e7"
import script from "./SizeFamilyDialog.vue?vue&type=script&lang=js"
export * from "./SizeFamilyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports